<template lang="pug">
table-base.notification-list-table
  //- ヘッダー部
  table-row-base.notification-list-table__row-header.text-medium
    table-header-base.notification-list-table__row-header__cell.align-left
      toggle-sort.notification-list-table__row-header__cell__toggle(
        :sortSetting='sort.title',
        @change-sort='sortChangeEvent($event, "title")'
      )
        slot(name='titleHeader')
    table-header-base.notification-list-table__row-header__cell.align-left
      toggle-sort.notification-list-table__row-header__cell__toggle(
        :sortSetting='sort.startDate',
        @change-sort='sortChangeEvent($event, "startDate")'
      )
        slot(name='startDateHeader')
    table-header-base.notification-list-table__row-header__cell.align-left
      toggle-sort.notification-list-table__row-header__cell__toggle(
        :sortSetting='sort.endDate',
        @change-sort='sortChangeEvent($event, "endDate")'
      )
        slot(name='endDateHeader')
    table-header-base.notification-list-table__row-header__cell.align-center
      slot(name='editHeader')
  template(v-for='notification in notificationDatas')
    //- 一覧表示部
    table-row-base.notification-list-table__row.text-small.font-medium
      table-data-base.notification-list-table__row__cell
        .notification-list-table__row__cell__text {{ notification.title }}
      table-data-base.notification-list-table__row__cell
        .notification-list-table__row__cell__text {{ notification.startDate }}
      table-data-base.notification-list-table__row__cell
        .notification-list-table__row__cell__text {{ notification.endDate }}
      table-data-base.notification-list-table__row__cell
        popup-edit.notification-list-table__row__cell__popup(
          :deleteEvent='deleteEvent',
          :editEvent='editEvent',
          :editId='notification.id'
        )
          template(#removeText)
            slot(name='popupRemoveText')
          template(#editText)
            slot(name='popupEditText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import ToggleSort from '@/components/molecules/manager/ToggleSort.vue'
import PopupEdit from '@/components/organisms/manager/PopupEdit.vue'
import { NotificationListType, NotificationListSortType } from '@/models/notificationModel'

/**
 * お知らせ一覧テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
    ToggleSort,
    PopupEdit,
  },
})
export default class NotificationListTable extends Vue {
  // ソート値（項目毎の昇順フラグ）
  @Prop()
  sort!: NotificationListSortType

  // ソート値変更時イベント
  @Prop()
  sortChangeEvent!: Function

  // お知らせ一覧情報
  @Prop()
  notificationDatas!: NotificationListType[]

  // 削除イベント
  @Prop()
  deleteEvent!: Function

  // 編集イベント
  @Prop()
  editEvent!: Function
}
</script>

<style lang="stylus" scoped>
.notification-list-table
  width 100%

  &__row-header,
  &__row
    border-bottom 1px solid var(--color-manager-list__border)

  &__row-header
    background var(--color-manager-list__background)

    &__cell
      padding 10px 20px

      &:nth-last-child(1)
        width 130px

  &__row
    background var(--color-manager-list__background)
    height 55px

    &__cell
      padding 0 20px

      &__popup
        justify-content center

    &:hover
      background var(--color-manager-list__hover)
</style>
